import React from 'react';

const Achievements = () => {
  const achievements = [
    {
      number: '10+',
      label: 'Years of Excellence',
      color: 'text-tango'
    },
    {
      number: '100+',
      label: 'Happy Clients',
      color: 'text-tango'
    },
    {
      number: '2',
      label: 'Product Categories',
      color: 'text-tango'
    },
    {
      number: '24/7',
      label: 'Customer Support',
      color: 'text-tango'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-catalina-blue text-center mb-12">Our Achievements</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {achievements.map((achievement, index) => (
            <div key={index} className="text-center">
              <div className={`text-5xl font-bold ${achievement.color} mb-3`}>
                {achievement.number}
              </div>
              <p className="text-gray-600 text-lg font-medium">{achievement.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;